import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HELMET_LOADING_TITLE } from '@ts/utils/constants';
import androidIcon192x192 from '@ts/images/favicon/android-icon-192x192.png';
import appleIcon114x114 from '@ts/images/favicon/apple-icon-114x114.png';
import appleIcon120x120 from '@ts/images/favicon/apple-icon-120x120.png';
import appleIcon144x144 from '@ts/images/favicon/apple-icon-144x144.png';
import appleIcon152x152 from '@ts/images/favicon/apple-icon-152x152.png';
import appleIcon180x180 from '@ts/images/favicon/apple-icon-180x180.png';
import appleIcon57x57 from '@ts/images/favicon/apple-icon-57x57.png';
import appleIcon60x60 from '@ts/images/favicon/apple-icon-60x60.png';
import appleIcon72x72 from '@ts/images/favicon/apple-icon-72x72.png';
import appleIcon76x76 from '@ts/images/favicon/apple-icon-76x76.png';
import favicon16x16 from '@ts/images/favicon/favicon-16x16.png';
import favicon32x32 from '@ts/images/favicon/favicon-32x32.png';
import favicon96x96 from '@ts/images/favicon/favicon-96x96.png';
import msIcon144x144 from '@ts/images/favicon/ms-icon-144x144.png';

export default function AppHelmet() {
    return (
        <Helmet>
            <title>{HELMET_LOADING_TITLE}</title>
            <meta httpEquiv="x-ua-compatible" content="IE=edge" />
            <meta charset="utf-8" />
            <link rel="manifest" href="/manifest.json" />
            <meta
                name="description"
                content="The USA's #1 booking website for activities, tours, and things to do. Browse reviews, deals, photos and more from over 1,000+ experiences. Low price guarantee on every booking."
            />

            <meta
                name="viewport"
                content="width=device-width,initial-scale=1,user-scalable=no,shrink-to-fit=no"
            />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="application-name" content="TripShock" />
            <meta name="apple-mobile-web-app-title" content="TripShock" />
            <meta name="theme-color" content="#2b3b46" />
            <meta name="msapplication-navbutton-color" content="#2b3b46" />
            <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
            <link rel="apple-touch-icon" sizes="57x57" href={appleIcon57x57} />
            <link rel="apple-touch-icon" sizes="60x60" href={appleIcon60x60} />
            <link rel="apple-touch-icon" sizes="72x72" href={appleIcon72x72} />
            <link rel="apple-touch-icon" sizes="76x76" href={appleIcon76x76} />
            <link rel="apple-touch-icon" sizes="114x114" href={appleIcon114x114} />
            <link rel="apple-touch-icon" sizes="120x120" href={appleIcon120x120} />
            <link rel="apple-touch-icon" sizes="144x144" href={appleIcon144x144} />
            <link rel="apple-touch-icon" sizes="152x152" href={appleIcon152x152} />
            <link rel="apple-touch-icon" sizes="180x180" href={appleIcon180x180} />

            <link rel="icon" type="image/png" sizes="192x192" href={androidIcon192x192} />
            <link rel="icon" type="image/png" sizes="32x32" href={favicon32x32} />
            <link rel="icon" type="image/png" sizes="96x96" href={favicon96x96} />
            <link rel="icon" type="image/png" sizes="16x16" href={favicon16x16} />

            <meta name="msapplication-TileColor" content="#ffffff" />
            <meta name="msapplication-TileImage" content={msIcon144x144} />

            <meta name="theme-color" content="#ffffff" />
            <link rel="preconnect dns-prefetch" href="https://fonts.gstatic.com/" crossOrigin />
            <link rel="preconnect dns-prefetch" href="https://api.tripshock.com/" crossOrigin />
            <link
                href="https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700&display=swap"
                rel="preload"
                as="style"
                onLoad="this.onload=null;this.rel='stylesheet'"
            />
        </Helmet>
    );
}
